(() => {
  const main = document.querySelector('#MainContent');
  if (!main) return;

  document.documentElement.classList.add('dao-motion-ready');

  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const template = main.dataset.template || '';
  const isHome = template === 'index';
  const path = window.location.pathname.replace(/\/$/, '');
  const isContactPage = path.endsWith('/pages/contact') || template === 'page.contact';
  const isDaoNotesPage = template === 'blog' || path.includes('/blogs/dao-notes') || path.includes('/blogs/news');

  if (isContactPage) main.classList.add('dao-contact-page');
  if (isDaoNotesPage) main.classList.add('dao-notes-page');

  const normalizeShopLinks = () => {
    document.querySelectorAll('a[href]').forEach((link) => {
      const href = link.getAttribute('href') || '';
      let url;
      try {
        url = new URL(href, window.location.origin);
      } catch (_error) {
        return;
      }
      if (url.origin !== window.location.origin || !/\/collections\/shop-objects-live\/?$/.test(url.pathname)) return;
      url.pathname = url.pathname.replace(/\/collections\/shop-objects-live\/?$/, '/collections/all');
      url.searchParams.set('view', 'shop-premium-1');
      link.setAttribute('href', `${url.pathname}${url.search}${url.hash}`);
    });
  };

  normalizeShopLinks();
  window.addEventListener('pageshow', normalizeShopLinks);
  setTimeout(normalizeShopLinks, 600);

  const initPolicyPage = () => {
    const policy = main.querySelector('.dao-policy-page');
    if (!(policy instanceof HTMLElement) || policy.dataset.motionEnhanced === 'true') return;

    policy.dataset.motionEnhanced = 'true';
    policy.classList.add('dao-policy-animated');

    const title = policy.querySelector('h1');
    if (title && !title.querySelector('.dao-policy-word')) {
      const words = (title.textContent || '').trim().split(/\s+/).filter(Boolean);
      if (words.length) {
        title.textContent = '';
        words.forEach((word, index) => {
          const span = document.createElement('span');
          span.className = 'dao-policy-word';
          span.textContent = word;
          span.style.setProperty('--dao-word-delay', `${160 + index * 46}ms`);
          title.append(span, document.createTextNode(index === words.length - 1 ? '' : ' '));
        });
        window.requestAnimationFrame(() => policy.classList.add('dao-policy-title-ready'));
      }
    }

    policy.querySelectorAll('.dao-policy-page__grid > div').forEach((card, index) => {
      if (!(card instanceof HTMLElement)) return;
      card.classList.add('dao-policy-card');
      card.style.setProperty('--dao-delay', `${Math.min(index, 5) * 75}ms`);
    });
  };

  initPolicyPage();
  window.addEventListener('pageshow', initPolicyPage);

  const splitLuxuryTitle = (title, className, readyClass) => {
    if (!(title instanceof HTMLElement) || title.querySelector(`.${className}`)) return;
    const words = (title.textContent || '').trim().split(/\s+/).filter(Boolean);
    if (!words.length) return;
    title.textContent = '';
    words.forEach((word, index) => {
      const span = document.createElement('span');
      span.className = className;
      span.textContent = word;
      span.style.setProperty('--dao-word-delay', `${120 + index * 54}ms`);
      title.append(span, document.createTextNode(index === words.length - 1 ? '' : ' '));
    });
    window.requestAnimationFrame(() => title.classList.add(readyClass));
  };

  const initContactPage = () => {
    if (!isContactPage || main.dataset.contactMotionEnhanced === 'true') return;
    main.dataset.contactMotionEnhanced = 'true';

    if (!document.getElementById('dao-contact-runtime-motion-style')) {
      const style = document.createElement('style');
      style.id = 'dao-contact-runtime-motion-style';
      style.textContent = `
        @media (prefers-reduced-motion: no-preference) {
          .dao-motion-ready .dao-contact-page .section-content-wrapper rte-formatter.text-block h2,
          .dao-motion-ready .dao-contact-page .section-content-wrapper rte-formatter.text-block p,
          .dao-motion-ready .dao-contact-page .section-content-wrapper rte-formatter.text-block a {
            animation: daoContactRuntimeCopyIn 920ms cubic-bezier(.18, .84, .2, 1) both;
          }

          .dao-motion-ready .dao-contact-page .section-content-wrapper rte-formatter.text-block h2 { animation-delay: 240ms; }
          .dao-motion-ready .dao-contact-page .section-content-wrapper rte-formatter.text-block p:nth-of-type(1) { animation-delay: 340ms; }
          .dao-motion-ready .dao-contact-page .section-content-wrapper rte-formatter.text-block p:nth-of-type(2) { animation-delay: 430ms; }
          .dao-motion-ready .dao-contact-page .section-content-wrapper rte-formatter.text-block p:nth-of-type(3) { animation-delay: 520ms; }

          .dao-motion-ready .dao-contact-page .section-content-wrapper rte-formatter.text-block a {
            position: relative;
            display: inline-block;
          }

          .dao-motion-ready .dao-contact-page .section-content-wrapper rte-formatter.text-block a::after {
            content: "";
            position: absolute;
            left: 0;
            right: 0;
            bottom: -.22em;
            height: 1px;
            background: linear-gradient(90deg, rgba(176, 138, 74, .95), transparent);
            transform: scaleX(0);
            transform-origin: left;
            animation: daoContactRuntimeRule 820ms 720ms cubic-bezier(.18, .84, .2, 1) both;
          }

          @keyframes daoContactRuntimeCopyIn {
            0% { opacity: 0; transform: translate3d(0, 18px, 0); filter: blur(2px); }
            100% { opacity: 1; transform: translate3d(0, 0, 0); filter: blur(0); }
          }

          @keyframes daoContactRuntimeRule {
            0% { transform: scaleX(0); }
            100% { transform: scaleX(1); }
          }
        }
      `;
      document.head.appendChild(style);
    }

    const title = main.querySelector('h1');
    if (title instanceof HTMLElement) title.dataset.daoEyebrow = 'Customer Care';
    splitLuxuryTitle(title, 'dao-policy-word', 'dao-policy-title-ready');

    main.querySelectorAll('.dao-contact-trust > div').forEach((card, index) => {
      if (!(card instanceof HTMLElement)) return;
      card.classList.add('dao-policy-card');
      card.style.setProperty('--dao-delay', `${220 + index * 85}ms`);
    });

    main.querySelectorAll('.contact-form__input, .contact-form .button').forEach((field, index) => {
      if (!(field instanceof HTMLElement)) return;
      field.style.setProperty('--dao-delay', `${260 + index * 55}ms`);
    });
  };

  const initDaoNotesPage = () => {
    if (!isDaoNotesPage || main.dataset.daoNotesMotionEnhanced === 'true') return;
    main.dataset.daoNotesMotionEnhanced = 'true';

    const title = main.querySelector('.blog-posts h1, h1');
    if (title instanceof HTMLElement) title.dataset.daoEyebrow = 'Dao Notes';
    splitLuxuryTitle(title, 'dao-policy-word', 'dao-policy-title-ready');

    main.querySelectorAll('.blog-post-item').forEach((card, index) => {
      if (!(card instanceof HTMLElement)) return;
      card.style.setProperty('--dao-delay', `${160 + Math.min(index, 7) * 80}ms`);
    });

    main.querySelectorAll('.dao-notes-submission label, .dao-notes-submission .button').forEach((field, index) => {
      if (!(field instanceof HTMLElement)) return;
      field.style.setProperty('--dao-delay', `${220 + Math.min(index, 10) * 48}ms`);
    });
  };

  initContactPage();
  initDaoNotesPage();
  window.addEventListener('pageshow', () => {
    initContactPage();
    initDaoNotesPage();
  });

  const templateName = template.split('.')[0];
  const revealSelectorsByTemplate = {
    collection: [
      '.dao-collection-hero__inner > *',
      '.dao-collection-nav',
      'product-card'
    ],
    product: [
      '.product-information__media',
      '.product-details > .group-block',
      '.product-details .group-block-content > *',
      '.dao-product-detail-image__header > *',
      '.dao-product-detail-image__frame',
      '.product-recommendations'
    ],
    page: [
      '.dao-policy-page__intro',
      '.dao-policy-page__grid > div',
      '.dao-contact-page h1',
      '.dao-contact-page .text-block',
      '.dao-contact-page .dao-contact-trust > div',
      '.dao-contact-page .contact-form',
      '.dao-contact-page .contact-form__input',
      '.dao-contact-page .contact-form .button'
    ],
    blog: [
      '.dao-notes-page .blog-posts h1',
      '.dao-notes-page .blog-post-item',
      '.featured-blog-posts-card',
      '.dao-notes-page .dao-notes-submission__intro > *',
      '.dao-notes-page .dao-notes-submission__form',
      '.dao-notes-page .dao-notes-submission label',
      '.dao-notes-page .dao-notes-submission .button'
    ],
    search: ['product-card']
  };
  const revealSelectors = revealSelectorsByTemplate[templateName] || [];

  const revealItems = isHome
    ? []
    : revealSelectors.length
      ? [...main.querySelectorAll(revealSelectors.join(','))]
        .filter((item, index, list) => list.indexOf(item) === index)
        .filter((item) => item instanceof HTMLElement && item.getBoundingClientRect().height > 0)
      : [];

  revealItems.forEach((item, index) => {
    item.classList.add('dao-site-reveal');
    item.style.setProperty('--dao-delay', `${Math.min(index % 5, 4) * 70}ms`);
  });

  if (!prefersReduced && revealItems.length && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('dao-in-view');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -7% 0px' }
    );

    revealItems.forEach((item) => observer.observe(item));
  } else {
    revealItems.forEach((item) => item.classList.add('dao-in-view'));
  }

  if (prefersReduced || isHome) return;

  let ticking = false;
  const updateDrift = () => {
    ticking = false;
    const maxScroll = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
    const progress = Math.max(0, Math.min(1, window.scrollY / maxScroll));
    main.style.setProperty('--dao-page-drift', `${progress * 100}`);
  };

  updateDrift();
  window.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateDrift);
  }, { passive: true });

  main.addEventListener('pointermove', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const card = target.closest('product-card, .product-card__content, .product-details > .group-block, .dao-product-detail-image__frame, .dao-contact-trust > div, .dao-contact-page .contact-form, .dao-notes-page .blog-post-item, .dao-notes-submission__form');
    if (!(card instanceof HTMLElement)) return;
    const rect = card.getBoundingClientRect();
    if (!rect.width || !rect.height) return;
    card.style.setProperty('--dao-x', `${((event.clientX - rect.left) / rect.width) * 100}%`);
    card.style.setProperty('--dao-y', `${((event.clientY - rect.top) / rect.height) * 100}%`);
  });
})();
